
import { defineComponent, ref, reactive, onMounted, nextTick, watch, toRefs, onUnmounted } from 'vue'
import {
  SearchOutlined,
  PlusCircleOutlined,
  InfoCircleFilled,
  RollbackOutlined,
  SyncOutlined,
  DoubleLeftOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined
} from '@ant-design/icons-vue'
import Table from '@/components/table.vue'
import Select from '@/components/select.vue'
import { useRoute } from 'vue-router'
import { hotApi } from '@/api/index'
import ws from '../websocket/index'
import * as echarts from 'echarts'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import { getMarketKeyById } from '@/utils/stock'
const __default__ = defineComponent({
  components: {
    SearchOutlined,
    PlusCircleOutlined,
    InfoCircleFilled,
    RollbackOutlined,
    SyncOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    Table,
    Select,
    ArrowUpOutlined,
    ArrowDownOutlined
  },
  setup() {
    const state: any = reactive({
      columns: [],
      tableData: [],
      columns1: [],
      tableData1: [],
      upTime: '',
      hotTimer: null,
      hotCur: null,
      prevHotCur: null, // 添加变量存储上一次的数据
      selectedRowId: 1,
      tags: [],
      shouldAutoSelect: false, // 添加标志来跟踪是否需要自动选中
      tabLoading: false
    })
    const activeKey = ref('1')
    const route = useRoute()
    const theme = route.query.theme || 'light'

    // 存储图表实例
    let chartInstance1: any = null
    let chartInstance2: any = null
    let currentChartData1: any = null
    let currentChartData2: any = null
    state.columns = [
      {
        title: '排名',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
        slots: { customRender: 'rankColor' } // 添加自定义渲染
      },
      {
        title: '板块名称',
        dataIndex: 'name',
        key: 'name',
        align: 'left',
        width: 150,
        slots: { customRender: 'bkName' }
      },
      {
        title: '最新',
        dataIndex: 'LastPrice',
        key: 'LastPrice',
        align: 'right',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '涨幅',
        dataIndex: 'increase',
        key: 'increase',
        align: 'right',
        slots: { customRender: 'increase' }
      },
      {
        title: '热度',
        dataIndex: 'hotValue',
        key: 'hotValue',
        align: 'right',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '领涨股',
        dataIndex: 'riseFirstGrpName',
        key: 'riseFirstGrpName',
        align: 'left',
        slots: { customRender: 'riseFirstGrpName' }
      },
      {
        title: '领涨涨幅',
        dataIndex: 'riseFirstGrpRise',
        key: 'riseFirstGrpRise',
        align: 'right',
        slots: { customRender: 'riseFirstGrpRise' }
      },
      {
        title: '涨跌家数',
        dataIndex: 'riseAFall',
        key: 'riseAFall',
        align: 'right',
        slots: { customRender: 'riseAFall' }
      },
      {
        title: '主力净流入',
        dataIndex: 'mainCleanForceIn',
        key: 'mainCleanForceIn',
        align: 'right',
        slots: { customRender: 'peopleCountColor' }
      }
    ]
    state.columns1 = [
      {
        title: '排名',
        dataIndex: 'rank',
        key: 'rank',
        align: 'center',
        slots: { customRender: 'rankColor' } // 添加自定义渲染
      },
      {
        title: '较昨日',
        dataIndex: 'changeRank',
        key: 'changeRank',

        align: 'center',
        slots: { customRender: 'changeRank' }
      },
      {
        title: '股票名称',
        dataIndex: 'name',
        key: 'name',
        align: 'left',
        slots: { customRender: 'stockName' }
      },
      {
        title: '最新',
        dataIndex: 'LastPrice',
        key: 'LastPrice',

        align: 'right',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '涨幅',
        dataIndex: 'increase',
        key: 'increase',
        align: 'right',
        slots: { customRender: 'increase' }
      },
      {
        title: '热度',
        dataIndex: 'hot',
        key: 'hot',
        align: 'right'
      }

    ]
    const removeDuplicateObj = (arr: any) => {
      // 缓存用于记录
      const newArr: any = []
      for (const t of arr) {
        // 检查缓存中是否已经存在
        if (newArr.find((c: any) => c.symbol === t.symbol && c.market === t.market)) {
          continue
        }
        newArr.push(t)
      }
      // 记录结果就是过滤后的结果
      return newArr
    }
    function subon(list: any) {
      nextTick(() => {
        // 列表去重
        const data = removeDuplicateObj(list)
        let stockList: Array<object> = []
        let keyList: Array<string> = []
        data.forEach((item: any) => {
          let obj = {
            symbol: item.symbol,
            market: item.market,
          } as object
          let str = item.symbol + item.market
          stockList.push(obj)
          keyList.push(str)
        })
        ws.websocket.safeSubscribeList(keyList, stockList)
      })
    }
    onMounted(() => {
      // 检查是否有路由参数需要自动选中
      const symbol = route.query.symbol as string
      const market = route.query.market as string
      if (symbol && market) {
        state.shouldAutoSelect = true
      }

      stopTimer()
      getHotList()
      startTimer()
      addResizeListener()
    })
    onUnmounted(() => {
      stopTimer()
      removeResizeListener()
      // 清理图表实例
      if (chartInstance1) {
        chartInstance1.dispose()
        chartInstance1 = null
      }
      if (chartInstance2) {
        chartInstance2.dispose()
        chartInstance2 = null
      }
    })
    function checkStock(obj: any) {
      console.log('选中111====', obj)
      state.tags = obj
      activeKey.value = '1'
      let index = 999
      //如果不在tab1,先切回tab1
      state.tableData.forEach((item: any) => {
        if (item.market == obj.MarketCode && item.symbol == obj.Code) {
          index = item.rank
        }
      })
      state.hotCur = { market: obj.MarketCode, symbol: obj.Code, index: index, name: obj.Name, changeRank: obj.changeRank }
      state.selectedRowId = index

      // 滚动到选中的行
      nextTick(() => {
        scrollToSelectedRow(index)
      })

      stopTimer()
      getHotList()
      startTimer()
    }

    // 滚动到选中的行
    function scrollToSelectedRow(rank: number) {
      console.log('滚动到排名:', rank)

      // 延迟执行，确保DOM已更新
      setTimeout(() => {
        // 查找表格容器
        const tableContainer = document.querySelector('.ant-table-body')
        if (!tableContainer) {
          console.log('未找到表格容器')
          return
        }

        // 查找目标行
        const targetRow = tableContainer.querySelector(`tr[data-row-key="${rank}"]`)
        let foundRow: any = null
        if (!targetRow) {
          console.log('未找到目标行，rank:', rank)
          // 尝试通过其他方式查找行
          const allRows = tableContainer.querySelectorAll('tr')
          for (let i = 0; i < allRows.length; i++) {
            const row = allRows[i]
            const rowKey = row.getAttribute('data-row-key')
            if (rowKey && parseInt(rowKey) === rank) {
              foundRow = row
              break
            }
          }
          if (!foundRow) {
            console.log('通过所有方式都未找到目标行')
            return
          }
        }

        const targetRowElement = targetRow || foundRow

        // 计算滚动位置
        const containerRect = tableContainer.getBoundingClientRect()
        const rowRect = targetRowElement.getBoundingClientRect()
        const scrollTop = tableContainer.scrollTop

        // 计算目标行相对于容器的位置
        const rowTop = rowRect.top - containerRect.top + scrollTop
        const rowHeight = rowRect.height
        const containerHeight = containerRect.height

        // 计算滚动位置，让目标行在容器中央
        const targetScrollTop = rowTop - (containerHeight / 2) + (rowHeight / 2)

        // 平滑滚动到目标位置
        tableContainer.scrollTo({
          top: Math.max(0, targetScrollTop),
          behavior: 'smooth'
        })

        console.log('滚动完成，目标位置:', targetScrollTop)
      }, 100) // 延迟100ms执行
    }

    // 根据symbol和market在tableData中查找对应的数据并触发checkStock
    function selectStockBySymbol(symbol: string, market: string) {
      console.log('根据symbol查找股票:', symbol, market)

      // 在tableData中查找匹配的股票
      const foundStock = state.tableData.find((item: any) => {
        return item.symbol === symbol && item.market === market
      })

      if (foundStock) {
        console.log('找到匹配的股票:', foundStock)
        // 构造checkStock需要的参数格式
        const stockObj = {
          Code: foundStock.symbol,
          MarketCode: foundStock.market,
          Name: foundStock.name,
          changeRank: foundStock.changeRank
        }
        // 触发checkStock方法
        checkStock(stockObj)
      } else {
        console.log('未找到匹配的股票，symbol:', symbol, 'market:', market)
        console.log('当前tableData:', state.tableData)
      }
    }
    function getEchart(dom: any, data: any, chartType: 'chart1' | 'chart2' = 'chart1') {
      // 如果图表实例已存在，先销毁
      if (chartType === 'chart1' && chartInstance1) {
        chartInstance1.dispose()
      } else if (chartType === 'chart2' && chartInstance2) {
        chartInstance2.dispose()
      }

      const chart = echarts.init(dom)

      // 存储图表实例和数据
      if (chartType === 'chart1') {
        // 对数据进行时间排序
        const sortedData = data.sort((a: any, b: any) => {
          // 将时间字符串转换为可比较的格式
          const timeA = a[0].split(':').map(Number)
          const timeB = b[0].split(':').map(Number)

          // 比较小时和分钟
          if (timeA[0] !== timeB[0]) {
            return timeA[0] - timeB[0]
          }
          return timeA[1] - timeB[1]
        })
        chartInstance1 = chart
        currentChartData1 = sortedData
        console.log('currentChartData1===', currentChartData1)
      } else {
        chartInstance2 = chart
        currentChartData2 = data
        console.log('currentChartData2===', currentChartData2)
      }

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',  // 显示 X 和 Y 轴的交叉指示线
            lineStyle: {
              type: 'dashed',  // 设置虚线
              color: '#B2B2B2',  // 虚线颜色
              width: 1  // 虚线宽度
            }
          },
          formatter: function (params: any) {
            const time = params[0].data[0]
            const rank = params[0].data[1]
            const hot = params[0].data[2]

            return `
                  <div style='color:#666;'>时间：${time}<div>
                  <div style='color:#666;'>排名：${rank}<div>
                  <div style='color:#666;'>热度：${hot}<div>
              `
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data,
            type: 'line'
          }
        ]
      }
      chart.setOption(option)
    }

    function showEmptyChart(domId: string, message: string) {
      const dom = document.getElementById(domId)
      if (!dom) return

      // 清空容器内容
      dom.innerHTML = ''

      // 根据主题设置颜色
      const isDark = theme === 'dark'
      const backgroundColor = isDark ? '#1f1f1f' : '#fafafa'
      const textColor = isDark ? '#ccc' : '#999'
      const borderColor = isDark ? '#404040' : '#d9d9d9'

      // 创建空数据提示元素
      const emptyDiv = document.createElement('div')
      emptyDiv.style.cssText = `
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: ${textColor};
        font-size: 14px;
        background-color: ${backgroundColor};
        border: 1px dashed ${borderColor};
        border-radius: 4px;
        transition: all 0.3s ease;
      `

      // 创建图标
      const icon = document.createElement('div')
      icon.innerHTML = '📊'
      icon.style.cssText = `
        font-size: 32px;
        margin-bottom: 8px;
        opacity: 0.6;
        filter: ${isDark ? 'brightness(0.8)' : 'none'};
      `

      // 创建文字
      const text = document.createElement('div')
      text.textContent = message
      text.style.cssText = `
        color: ${textColor};
        font-size: 14px;
      `

      emptyDiv.appendChild(icon)
      emptyDiv.appendChild(text)
      dom.appendChild(emptyDiv)
    }
    // 取消订阅
    function suboff(data: any) {
      const _data = data
      if (!_data.length) return
      let stockList: Array<object> = []
      let keyList: Array<string> = []
      data.forEach((item: any) => {
        let obj = {
          symbol: item.symbol,
          market: item.market,
        } as object
        let str = item.symbol + item.market
        stockList.push(obj)
        keyList.push(str)
      })
      ws.websocket.safeUnsubscribeList(keyList, stockList)
    }
    ws.websocket.on('onHQLIST', msg => {
      if (state.tableData && state.tableData.length) {
        state.tableData.forEach((item: any) => {
          msg?.QuoteData?.DynaData?.forEach(msgItem => {
            if (item.symbol !== msgItem.InstrumentID) return
            item.LastPrice = msgItem.LastPrice || 0
            item.increase = msgItem.UpdownRate * 100 || 0
          })
        })
      }
      state.tableData.slice(0, 0)
    })
    //请求概念榜/行业榜
    function customRow(record: any) {
      return {
        onClick: () => {
          state.selectedRowId = record.rank
          state.hotCur = { market: record.market, symbol: record.symbol, index: record.rank, name: record.name, changeRank: record.changeRank }
          console.log('打印点击的record===', record)

          // 滚动到选中的行
          nextTick(() => {
            scrollToSelectedRow(record.rank)
          })

          getHotDetail(state.hotCur.market, state.hotCur.symbol)
        },
        onDblclick: () => {
          // 双击事件处理逻辑
          console.log('双击了行:', record)

          // 优化1: 参数验证
          if (!record || !record.symbol || !record.market) {
            console.warn('无法打开分时图：缺少必要的股票信息')
            return
          }

          window.open(`gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params><code>${record.symbol}</code><market_letter>${record.market}</market_letter><technique_type>0</technique_type><technique_name></technique_name><element_InfoTab><SubTabName></SubTabName></element_InfoTab><QUOTE_TAB_pt><SubTabName></SubTabName></QUOTE_TAB_pt><level2_orderchart_type>-1</level2_orderchart_type><StyleName>FSZS</StyleName><TabName>分时图</TabName><flag_container_style>R</flag_container_style></params>`)

        }
      }
    }

    //请求概念榜/行业榜
    function customRow2(record: any) {
      return {
        onDblclick: () => {
          // 双击事件处理逻辑
          console.log('双击了行:', record)

          // 优化1: 参数验证
          if (!record || !record.symbol || !record.market) {
            console.warn('无法打开分时图：缺少必要的股票信息')
            return
          }

          window.open(`gw://funccall?funcname=OnFireCommand;setcurrent=1;Command=fszs;param=<params><code>${record.symbol}</code><market_letter>${record.market}</market_letter><technique_type>0</technique_type><technique_name></technique_name><element_InfoTab><SubTabName></SubTabName></element_InfoTab><QUOTE_TAB_pt><SubTabName></SubTabName></QUOTE_TAB_pt><level2_orderchart_type>-1</level2_orderchart_type><StyleName>FSZS</StyleName><TabName>分时图</TabName><flag_container_style>R</flag_container_style></params>`)

        }
      }
    }
    function setRowClassName(record: any) {
      return record.rank === state.selectedRowId ? 'selected-row' : '';
    }
    function getHotPList(key: any) {
      hotApi.hotPList({
        plateType: key == '2' ? 'XBHS.GN' : 'XBHS.HY',
        limit: 100
      }).then((res: any) => {
        suboff(state.tableData)
        console.log('getHotPList打印===', res)
        state.upTime = res.currentTime ? window.moment(res.currentTime * 1000).format('HH:mm') : '—'
        if (res.data) {
          state.tableData = res.data.map((item: any, index: any) => {
            item.index = index
            return item
          })
          subon(state.tableData)
        } else {
          state.tableData = []
        }
      }).finally(() => {
        // 强制重新渲染table组件
      })
    }
    function getHotList() {
      hotApi.hotList({ pageNo: 1, pageSize: 100, token: route.query.token }).then((res: any) => {
        suboff(state.tableData)
        if (res.data) {
          // 在更新hotCur前保存上一次的数据
          state.prevHotCur = { ...state.hotCur }
          //判断选中的代码是否在前100，如不在前一百,更新为第1条，如在前100，保留原来代码；进行详情请求
          state.hotCur = state.hotCur?.index == 999 ? state.hotCur : findHotCur(res.data, state.hotCur)

          console.log('计算名次变化===', state.hotCur, state.prevHotCur)
          // 计算名次变化
          if (state.prevHotCur && state.hotCur && state.prevHotCur.index !== undefined && state.hotCur.index !== undefined) {
            state.hotCur.rankChange = state.prevHotCur.index - state.hotCur.index
            console.log('计算名次变化===', state.hotCur.rankChange)
          }
          getHotDetail(state.hotCur.market, state.hotCur.symbol)
          state.tableData = res.data
          subon(state.tableData)

          // 数据加载完成后，检查是否需要根据路由参数自动选中股票 market
          if (state.shouldAutoSelect) {
            const symbol = route.query.symbol as string
            const market = route.query.market as string

            // 将market id转换为对应的键名
            let marketKey = market
            if (market) {
              const convertedKey = getMarketKeyById(market)
              if (convertedKey) {
                marketKey = convertedKey
              } else {
                console.warn('未找到对应的market键名，id:', market)
              }
            }

            if (symbol && marketKey) {
              nextTick(() => {
                selectStockBySymbol(symbol, marketKey)
                state.shouldAutoSelect = false // 重置标志，避免重复选中
              })
            }
          }
        } else {
          state.tableData = []
        }
      }).finally(() => {
        // 强制重新渲染table组件
      })
    }
    function startTimer() {
      state.hotTimer = setInterval(() => {
        getHotList()
      }, 60 * 1000)
    }
    function stopTimer() {
      if (state.hotTimer) {
        clearInterval(state.hotTimer)
        state.hotTimer = null
      }
    }
    function findHotCur(list: any, obj: any) {
      let temp: any
      console.log('findHotCur===', list, obj)
      if (state.hotCur) {
        list.forEach((item: any) => {
          if (item.market == obj.market && item.symbol == obj.symbol) {
            temp = { market: item.market, symbol: item.symbol, index: item.rank, name: item.name, changeRank: item.changeRank }
          }
        })
      }
      if (temp) {
        return temp
      } else {
        state.selectedRowId = 1
        return { market: list[0].market, symbol: list[0].symbol, index: 1, name: list[0].name, changeRank: list[0].changeRank }
      }
    }

    function formatTimestampToDate(timestamp: number): string {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始需 +1
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    function changeData(data: any, type: string) {
      const resData: [string, number, number][] = []; // 明确 resData 的类型
      data.map((item: any) => {
        item.time = type == 'time' ? window.moment(item.time * 1000).format('HH:mm') : formatTimestampToDate(item.time)
        resData.push([item.time, item.rank, item.hot])
      })
      return resData
    }
    // 防抖函数
    function debounce(func: Function, wait: number) {
      let timeout: any
      return function executedFunction(this: any) {
        const args = arguments
        const later = () => {
          clearTimeout(timeout)
          func.apply(this, args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    }

    // 重新渲染图表的函数
    function resizeCharts() {
      if (chartInstance1 && currentChartData1) {
        const dom1 = document.getElementById('echarts1')
        if (dom1) {
          getEchart(dom1, currentChartData1, 'chart1')
        }
      }
      if (chartInstance2 && currentChartData2) {
        const dom2 = document.getElementById('echarts2')
        if (dom2) {
          getEchart(dom2, currentChartData2, 'chart2')
        }
      }
    }

    // 创建防抖的resize函数
    const debouncedResizeCharts = debounce(resizeCharts, 300)

    // 添加resize事件监听器
    function addResizeListener() {
      window.addEventListener('resize', debouncedResizeCharts)
    }

    // 移除resize事件监听器
    function removeResizeListener() {
      window.removeEventListener('resize', debouncedResizeCharts)
    }

    function getHotDetail(market: any, symbol: any) {
      hotApi.hotMin({ market, symbol }).then((res: any) => {

        if (res.data && res.data.list && res.data.list.length > 0) {
          getEchart(document.getElementById('echarts1'), changeData(res.data.list, 'time'), 'chart1')
          state.hotCur.index = res.data.list[res.data.list.length - 1].rank
        } else {
          showEmptyChart('echarts1', '暂无实时变动数据')
        }
        console.log('getHotDetail打印===', res.data && res.data.currentTime ? window.moment(res.data.currentTime * 1000).format('HH:mm') : '—')
        state.upTime = res.data.updateTime ? window.moment(res.data.updateTime * 1000).format('HH:mm') : '—'
      })
      hotApi.hotHis({ market, symbol }).then((res: any) => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          getEchart(document.getElementById('echarts2'), changeData(res.data.list, 'date'), 'chart2')
        } else {
          showEmptyChart('echarts2', '暂无历史趋势数据')
        }
      })
    }
    function tabClick(key: any) {
      activeKey.value = key
      state.tabLoading = true

      // 延迟数据加载，让tab切换动画先完成
      nextTick(() => {
        setTimeout(() => {
          if (key == 1) {
            stopTimer()
            getHotList()
            startTimer()
          } else {
            state.tags = []
            stopTimer()
            getHotPList(key)
          }
          state.tabLoading = false
        }, 150) // 延迟150ms
      })
    }

    return {
      ...toRefs(state),
      activeKey,
      // tableKey,
      customRow,
      customRow2,
      tabClick,
      setRowClassName,
      checkStock,
      selectStockBySymbol,
      scrollToSelectedRow,
      theme
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "66267cab": (_ctx.theme === "dark" ? "#fff" : "#000"),
  "9c65b0d0": (_ctx.theme === "dark" ? "#333" : "#f2f2f2")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__